import { render } from "./FridgeDetailsTab.vue?vue&type=template&id=1386be27&scoped=true&ts=true"
import script from "./FridgeDetailsTab.vue?vue&type=script&lang=ts"
export * from "./FridgeDetailsTab.vue?vue&type=script&lang=ts"

import "./FridgeDetailsTab.vue?vue&type=style&index=0&id=1386be27&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1386be27"]])

export default __exports__